/**
 * The app side of the guest prefetch.
 *
 * On a guest cold boot the lookup is already in flight before this bundle is even parsed:
 * an inline script in index.html fires it at HTML parse time and leaves the promise on
 * `window.__guestPrefetch`. See that script for why it lives in the HTML rather than here.
 *
 * `window` is the handover point precisely because the two halves cannot share a module —
 * the starting half has to run before any module chunk loads.
 */

/**
 * The in-flight lookup for `code`, or undefined when there is none to use.
 *
 * Resolves to `undefined` rather than rejecting whenever the prefetched response was not a
 * usable success envelope, so callers fall back to the normal request and failures surface
 * through the path that already knows how to report them.
 *
 * Single use: a retry, or a second resolve of the same code, goes through the normal request
 * rather than replaying a response that has already been found wanting.
 */
export function takeGuestPrefetch(code: string): Promise<any> | undefined {
  const prefetch = window.__guestPrefetch;
  if (!prefetch || prefetch.code !== code) return undefined;
  window.__guestPrefetch = undefined;
  return prefetch.request;
}
